import { render, staticRenderFns } from "./FreeModeAlertForSelectors.vue?vue&type=template&id=1ef29cb2&"
import script from "./FreeModeAlertForSelectors.vue?vue&type=script&lang=ts&"
export * from "./FreeModeAlertForSelectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports